import {CrmStrategyBaseClass} from '../crm-strategy-base-class'


export class ZendeskService extends CrmStrategyBaseClass {
  constructor() {
    super();
  }

  getTypeString() {
    return 'zendesk'
  }

  getDefaultLoginUrl() {
    return 'https://{subdomain}.zendesk.com';
  }

  getNewContactCreationMode(organization) {
    return {
      mode: 'internal-form'
    };
  }

  canMakeIndirectSearch(){
    return false;
  }

  canChooseSearchType(){
    return false;
  }

  defaultSearchType(){
    return 'exact'
  }

  static ZendeskFactory() {
    return new ZendeskService();
  }
}
ZendeskService.ZendeskFactory.$inject = [];
